var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.2,
    height: 35.2,
    rx: 17.6,
    fill: "#E8F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.9985V10H20.1637C20.8507 10 21.4881 10.161 22.0752 10.4793C22.6624 10.7991 23.173 11.216 23.6043 11.7294C24.037 12.2421 24.3779 12.8179 24.6256 13.4581C24.8762 14.0984 25 14.7329 25 15.3609C25 16.0222 24.8849 16.6487 24.6511 17.2383C24.4187 17.8285 24.1003 18.3586 23.6953 18.8263C23.2903 19.2954 22.8139 19.6892 22.2653 20.0097C21.7168 20.3295 21.1224 20.5557 20.4799 20.6884C20.4019 20.7102 20.2897 20.7334 20.147 20.7551C20.0027 20.7769 19.9197 20.7885 19.8971 20.7885H16.1076V26H13V25.9985ZM16.1419 12.9781V17.7429H20.0974C20.375 17.7429 20.627 17.6683 20.8536 17.5189C21.0809 17.3695 21.2724 17.1795 21.4276 16.9475C21.5828 16.7169 21.7044 16.4653 21.7933 16.1955C21.8814 15.9243 21.9266 15.6676 21.9266 15.4254C21.9266 14.9737 21.829 14.5545 21.6367 14.1688C21.4415 13.783 21.1391 13.4741 20.7297 13.2421C20.6634 13.1978 20.5586 13.1427 20.4136 13.076C20.2701 13.0093 20.1645 12.9774 20.0974 12.9774H16.1419V12.9781Z",
    fill: "#33A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a4ee1aab2014d3ea37cdef09f11e6e6c.svg";
export { ForwardRef as ReactComponent };